import { FormGroup } from '@angular/forms';
    
export function RetypedValidator(controlName: string, matchingControlName: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.retypedValidator) {
            return;
        }
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ retypedValidator: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}